// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"436":"91f865a2","642":"bca86fae"}[chunkId] + ".js";
};